import React, { useContext } from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import styled from "styled-components";

import ApolloClientConfigurator from "./helpers/apolloClient.helper";
import { AuthenticationContext } from "./components/Authentication.context";
import envConfig from "./helpers/envconfig.helper";
import MainScreen from "./screens/Main.screen";
import Header from "./components/Header";
import Menu from "./components/Menu";

const Container = styled.div`
  display: grid;
  grid-template-columns: 400px 1fr;
  grid-template-rows: 100%;
  grid-gap: 10px;
  grid-row: 1;
  margin: 60px;
`;

function App() {
  const { accessToken } = useContext(AuthenticationContext);
  const client = new ApolloClientConfigurator({
    uri: envConfig.REACT_APP_BACKEND_URI,
    accessToken
  }).Client();

  return (
    <ApolloProvider client={client}>
      <Header>Hello</Header>
      <Container>
        <Menu />
        <MainScreen />
      </Container>
    </ApolloProvider>
  );
}

export default App;
